import { render, staticRenderFns } from "./FeedbackSubjectIndex.vue?vue&type=template&id=4d7f809a&lang=pug"
import script from "./FeedbackSubjectIndex.vue?vue&type=script&lang=js"
export * from "./FeedbackSubjectIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports